import React from "react";
import ReactModal from "react-modal";
import Icon from "components/Icon";

class DeleteModal extends React.Component {
  state = {
    showModal: false
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id);
  };

  render() {
    const { children, title, errors } = this.props;
    return (
      <div>
        <button
          type="button"
          className="btn btn-danger"
          onClick={this.handleOpenModal}
        >
          <Icon icon="times" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Er du sikker på du vil slette "{title}"?
                </h5>
              </div>
              <div className="modal-body">
                Innhold som slettes:{" "}
                <div className="alert alert-warning">{children}</div>
                {errors && <div className="alert alert-danger">{errors}</div>}
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={this.handleDelete}>
                  Slett
                </button>
                <button className="btn" onClick={this.handleCloseModal}>
                  Avbryt
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/DeleteModal.js